import type { MeasureLabelWidth } from "./types";

// Average glyph width of a bold sans-serif, used where no canvas context exists (tests)
const FALLBACK_GLYPH_WIDTH_FACTOR = 0.6;

let measuringContext: CanvasRenderingContext2D | null | undefined;

const getMeasuringContext = () => {
  if (measuringContext !== undefined) return measuringContext;
  measuringContext =
    typeof document === "undefined"
      ? null
      : document.createElement("canvas").getContext("2d");
  return measuringContext;
};

export const measureLabelWidth: MeasureLabelWidth = ({
  text,
  fontSize,
  fontFamily,
  fontWeight,
}) => {
  const context = getMeasuringContext();
  if (!context) return text.length * fontSize * FALLBACK_GLYPH_WIDTH_FACTOR;
  context.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  return context.measureText(text).width;
};
